$(document).ready(function () {
    window.alertSuccess = function (msg) {
        Swal.fire({
            position: 'center',
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 1500,
        })
    }

    window.alertError = function (msg) {
        Swal.fire({
            position: 'center',
            icon: "error",
            title: msg,
            showConfirmButton: true,
        })
    }

    window.alertWithBtn = function (msg) {
        Swal.fire(
            '',
            msg,
            'success'

        )
    }

});
